import { useSchedulingQuery as useQuery } from "./useSchedulingQuery";
import { listAllAvailabilityRules } from "../../components/api/Scheduling/availabilityRules";
import { onError } from "./onError";

export const availabilityRuleKeys = {
  list: (organizationRef, scheduleId, active) => [
    "scheduling-availability-rules",
    organizationRef,
    scheduleId,
    active,
  ],
};

export function useAvailabilityRulesQuery({
  organizationRef,
  scheduleId,
  active,
  onSuccess,
  enabled = true,
}) {
  return useQuery(
    availabilityRuleKeys.list(organizationRef, scheduleId, active),
    ({ signal, consistency }) =>
      listAllAvailabilityRules({
        organizationRef,
        limit: 500, signal, consistency,
        scheduleId,
        ...(active === true || active === false ? { active } : {}),
      }),
    {
      enabled: !!organizationRef && !!scheduleId && enabled,
      keepPreviousData: false,
      staleTime: 60000, refetchOnWindowFocus: false, retry: false,
      onSuccess,
      onError,
    }
  );
}
